import moment from 'moment';

export default {
  toDateString(value) {
    if (typeof value !== 'string') {
      return console.warn('Incorrect data passed to toDateString', value);
    }

    const date = new Date(value);
    return date.toLocaleDateString('en-AU');
  },
  toDateTimeString(value) {
    if (typeof value !== 'string') {
      return console.warn('Incorrect data passed to toDateTimeString', value);
    }

    const date = new Date(value);
    return date.toLocaleString('en-AU');
  },
  timeAgo(value){
    // Accepts a date string, returns time difference in sentence form:
    // an hour ago, 5 hours ago, etc.
    if (typeof value !== 'string') {
      return console.warn('Incorrect data passed to timeAgo', value);
    }

    return moment(value).fromNow()
  }
};
